import React from 'react';
import { Link } from 'react-router-dom';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const Footer: React.FC = () => {
  return (
    <footer className="bg-primary-dark text-white relative z-50 overflow-hidden">
      {/* Main Footer */}
      <div className="container-main py-12 sm:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10">
        {/* Brand */}
        <div className="lg:col-span-1 min-w-0">
          <Link to="/" className="inline-block mb-4">
            <img
              src="/images/home/Manlab-Medicals-Incorporated-White.png"
              alt="Manlab Medicals Incorporated"
              className="h-16 md:h-20 lg:h-24 w-auto object-contain"
            />
          </Link>
          <p className="text-white/60 text-sm leading-relaxed mb-4 break-words">
            Established 10 years ago in Zimbabwe, serving sub-Saharan and African markets.
          </p>
          <p className="text-white/40 text-xs">CE Certified · FDA Approved Products</p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-accent font-bold text-sm uppercase tracking-widest mb-5">Quick Links</h4>
          <ul className="space-y-3">
            {[
              { label: 'Home', path: '/' },
              { label: 'Services', path: '/services' },
              { label: 'Shop', path: '/shop' },
              { label: 'About Us', path: '/about' },
              { label: 'Contact', path: '/contact' },
            ].map(l => (
              <li key={l.path}>
                <Link to={l.path} className="text-white/60 hover:text-accent text-sm transition-colors flex items-center gap-1">
                  <ChevronRightIcon fontSize="small" className="text-accent" />
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Product Categories */}
        <div>
          <h4 className="text-accent font-bold text-sm uppercase tracking-widest mb-5">Categories</h4>
          <ul className="space-y-3">
            {[
              'Electrosurgical Equipment',
              'Medical Supplies',
              'Laboratory Equipment',
              'OB/GYN Instruments',
              'Forceps & Clamps',
              'LeadCare Products',
            ].map(cat => (
              <li key={cat} className="text-white/60 text-sm flex items-center gap-1">
                <ChevronRightIcon fontSize="small" className="text-accent flex-shrink-0" />
                {cat}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="min-w-0">
          <h4 className="text-accent font-bold text-sm uppercase tracking-widest mb-5">Contact</h4>
          <ul className="space-y-4">
            <li className="flex gap-3">
              <LocationOnIcon className="text-accent flex-shrink-0 mt-0.5" fontSize="small" />
              <span className="text-white/60 text-sm leading-relaxed">
                130041 New Stands, Chizhanje,<br />Mabvuku, Harare, Zimbabwe
              </span>
            </li>
            <li className="flex gap-3">
              <PhoneIcon className="text-accent flex-shrink-0" fontSize="small" />
              <div>
                <a href="tel:+263774134805" className="text-white/60 hover:text-accent text-sm block transition-colors">(+263) 77 413 4805</a>
              </div>
            </li>
            <li className="flex gap-3">
              <EmailIcon className="text-accent flex-shrink-0" fontSize="small" />
              <div className="break-all">
                <a href="mailto:sales@manlab.co.zw" className="text-white/60 hover:text-accent text-sm block transition-colors">sales@manlab.co.zw</a>
                <a href="mailto:tendai@manlab.co.zw" className="text-white/60 hover:text-accent text-sm block transition-colors">tendai@manlab.co.zw</a>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container-main py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-sm text-center sm:text-left">© {new Date().getFullYear()} Manlab Medicals Incorporated. All rights reserved.</p>
          <div className="flex flex-wrap items-center justify-center sm:justify-end gap-x-4 gap-y-1">
            <p className="text-white/30 text-xs">CE Certified · FDA Approved · Zimbabwe</p>
            <a href="https://www.spemedia.co.zw/" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-accent text-xs transition-colors">Designed by speMEDIA</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
